import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import {trackPanelSearchCleared} from '../../../services/analytics';
import {usePanelSearchInputContext} from '../../../state/panelbank/PanelSearchContextProvider';
import {OptionTypeBase} from '../types';
import {SearchHistory} from './SearchHistory';
import {trackSearchHistory} from './searchHistoryEvents';

export const PanelSearchInput: React.FC = () => {
  const [inputValue, setInputValue] = useState('');
  const {searchQuery, onChangeSearchQuery, onAddToHistory, searchHistory} =
    usePanelSearchInputContext();

  const [selectedOption, setSelectedOption] = useState<OptionTypeBase | null>(
    null
  );

  const onClear = (event: React.MouseEvent<HTMLButtonElement>) => {
    trackPanelSearchCleared();
  };

  const onBlur = () => {
    // when to add to search history is a bit tricky - we chose blur since
    // it is a reasonable proxy for "the user finished editing the search",
    // and trying to save after X seconds of pause could be wrong if a
    // user stopped to think of something while typing a search.
    if (!inputValue) {
      return;
    }
    onAddToHistory?.(inputValue);
    trackSearchHistory({
      action: 'Item added',
      location: 'panel bank search',
    });
  };

  const onOptionChange = (newValue: OptionTypeBase | string) => {
    const newOption =
      typeof newValue === 'string'
        ? {value: newValue, label: newValue}
        : newValue;
    setSelectedOption(newOption);
  };

  return (
    <Tailwind style={{width: '100%'}}>
      <SearchHistory
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        searchHistory={searchHistory}
        onOptionChange={onOptionChange}
        onBlur={onBlur}
        setInputValue={(newValue: string) => {
          setInputValue(newValue);
          onChangeSearchQuery(newValue);
        }}
        inputValue={inputValue}
        searchQuery={searchQuery}
        placeholderText={'Search panels with regex'}
        onClear={onClear}
        maxItems={10}
        focusOnPageLoad={true}
        dataTest="panel-search-input"
      />
    </Tailwind>
  );
};
